export const tagPath = 'tags'
export const favPagePath = 'my-favourites'
